/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Injector, InjectionToken} from '@angular/core';
import {MdDialogRef} from './dialog-ref';

export const /** @type {?} */ MD_DIALOG_DATA = new InjectionToken<any>('MdDialogData');
/**
 * Custom injector type specifically for instantiating components with a dialog.
 */
export class DialogInjector implements Injector {
/**
 * @param {?} _parentInjector
 * @param {?} _dialogRef
 * @param {?} _data
 */
constructor(
private _parentInjector: Injector,
private _dialogRef: MdDialogRef<any>,
private _data: any) { }
/**
 * @param {?} token
 * @param {?=} notFoundValue
 * @return {?}
 */
get(token: any, notFoundValue?: any): any {
    if (token === MdDialogRef) {
      return this._dialogRef;
    }

    if (token === MD_DIALOG_DATA) {
      return this._data;
    }

    return this._parentInjector.get<any>(token, notFoundValue);
  }
}

function DialogInjector_tsickle_Closure_declarations() {
/** @type {?} */
DialogInjector.prototype._parentInjector;
/** @type {?} */
DialogInjector.prototype._dialogRef;
/** @type {?} */
DialogInjector.prototype._data;
}

